import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import { SlDrawer } from '@shoelace-style/shoelace/dist/react';
import PreviewFrameEdit from "../PreviewFrameEdit";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";


import { roles } from "../../utils/constants";
export const creativewiseReportsContext = React.createContext();
function CreativeWise(props) {
  const navigate = useNavigate();
  const [completeData, setCompleteData] = useState([])
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [reportData, setReportData] = useState([])
  const [creativePreview, setCreativePreview] = useState([])
  const [tablePermissions, setTablePermissions] = useState(props.permissions);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    setData(completeData.slice(event.selected * config.PER_PAGE,event.selected * config.PER_PAGE + config.PER_PAGE ))
  };

  const getdata = async (page = 0) => {
    setLoader(true);
    try {
      let res = await api({
        url: "/order/orderwiseReports",
        method: "POST",
        responseType: "json",
        data: {
          order_id: props.order_id,
          action: "creativewise",
        },
      });
      if (res.code === 200) {
        setCompleteData(res.data.creativePreviews);
        setData(res.data.creativePreviews.slice(0,config.PER_PAGE))
        setTotalPages(Math.ceil(res.data.creativePreviews.length / config.PER_PAGE));
        setReportData(Object.entries(res.data.totalres))
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  useEffect(() => {
    getdata();
  }, []);
  const getPostViews = async(creative_id) =>{
    try {
      const post_idsResult = await api({
        url: "lineitems/getPost_idsOfBrand",
        method: "POST",
        responseType: "json",
        data: {creative_id}
      })
      const post_ids = post_idsResult.data
      const previews = await brandAdsPreview(post_ids)
    } catch (error) {
      console.error("Error @ getPostViews", error)
    }
  }
  const brandAdsPreview = async(post_ids)=>{
    try {
      const res = await api({
        url : "lineitems/post_idsPreview",
        method: "POST",
        responseType: 'json',
        data: {post_ids}
      })
      setCreativePreview(res.data)
    } catch (error) {
      console.error('Error @ brandAdsPreview', error)
    }
  }
  return (
    <>
      <div className="overflow-x-auto mb-4">
        <table className="table table-bordered">
          <thead>
            <tr>
              {/* Campaign Creation */}
              {/* <th scope="col">Campaign Id</th> */}
              <th scope="col">Creative Name</th>
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv Impressions</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv Clicks</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv CTR(%)</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv ECPM</th>
                )}
              {localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('impressions') ? (
                <th>Audience Viewed</th>
              ) : localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('impressions') ? (
                <th scope="col">Impressions</th>
                ) : (localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role") !== roles.salesperson) ? (
                <th>Impressions</th>
              ) : null}
              {localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('clicks') ? (
                <th>Audience Engaged</th>
              ) : localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('clicks') ? (
                <th scope="col">Clicks</th>
                ) : (localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role") !== roles.salesperson) ? (
                <th>Clicks</th>
              ) : null}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">CTR(%)</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">ECPM</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                <th scope="col">Advertiser Spent</th>
              )}
              {((localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role") !== roles.salesperson) || (localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('spent')) || localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('spent')) ? (<th scope="col">Spent</th>) : null}
              {localStorage.getItem("role") === roles.ops && (
                <th>E Adv Impressions</th>
              )}
              {localStorage.getItem("role") === roles.ops && (
                <th>E Impressions</th>
              )}
              {localStorage.getItem("role") === roles.ops && (
                <th>Actual Clicks</th>
              )}
              {localStorage.getItem("role") === roles.ops && <th>Shares</th>}
              <th></th>
            </tr>
          </thead>
          {data?.length && !loader ? (
            <tbody>
              {data?.map((citem, index) => {
                let item = reportData.filter(ditem => +ditem[0] === +citem.creative_id || +ditem[0] === +citem.dfp_creative_id)[0]
                return (
                  <tr key={index}>
                    <td onClick={() => {props.setCreativeReportDetails({creative_id: citem.dfp_creative_id ? citem.dfp_creative_id : citem.creative_id, creative_name: citem.name})}} style={{color: "blue", cursor: "pointer"}}>{citem.name}</td>
                      {localStorage.getItem("role") === roles.ops && (
                          <td>{item ? parseInt(item[1]?.adv_total_imp) : 0}</td>
                        )}
                      {localStorage.getItem("role") === roles.ops && (
                          <td>{item ? parseInt(item[1]?.adv_total_click) : 0}</td>
                        )}
                        {localStorage.getItem("role") === roles.ops && (
                          <td>
                            {item && item[1]?.adv_total_click > 0 && item[1]?.adv_total_imp > 0
                              ? (
                                  (item[1].adv_total_click / item[1].adv_total_imp) *
                                  100
                                ).toFixed(2)
                              : 0}
                          </td>
                        )}
                        {localStorage.getItem("role") === roles.ops && (
                            <td>
                              {item ? ((item[1]?.adv_spent / item[1]?.adv_total_imp) * 1000).toFixed(2) : 0}
                            </td>
                          )}
                        
                      {item ? localStorage.getItem("role") === roles.ops
                      ? <td> {item[1]?.total_imp}</td>
                      : ((localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('impressions')) ||
                        (localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('impressions')) || localStorage.getItem("role") === roles.financer)
                        ? <td>{parseInt(item[1]?.adv_total_imp)}</td>
                        : null
                      : (((localStorage.getItem("role") === roles.ops) ||
                        (localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('impressions')) ||
                        (localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('impressions')))|| localStorage.getItem("role") === roles.financer)
                        ? <td>{0}</td>
                        : null}

                    {item ? localStorage.getItem("role") === roles.ops
                      ? <td> {item[1]?.total_click}</td>
                      : ((localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('clicks')) ||
                        (localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('clicks'))|| localStorage.getItem("role") === roles.financer)
                        ? <td>{parseInt(item[1]?.adv_total_click)}</td>
                        : null
                      : (((localStorage.getItem("role") === roles.ops) ||
                        (localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('clicks')) ||
                        (localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('clicks')))|| localStorage.getItem("role") === roles.financer)
                        ? <td>{0}</td>
                        : null}
                    {localStorage.getItem("role") === roles.ops && (
                        <td>
                          {item ?item[1]?.total_click > 0 && item[1]?.total_imp > 0
                            ? (
                                (item[1]?.total_click / item[1]?.total_imp) *
                                100
                              ).toFixed(2)
                            : 0 : 0}
                        </td>
                      )}
                    {localStorage.getItem("role") === roles.ops && (
                        <td>
                          {item ? ((item[1]?.total_spent / item[1]?.total_imp) * 1000).toFixed(2) : 0}
                        </td>
                      )}

                    {localStorage.getItem("role") === roles.ops && (
                        <td>
                          {item ? (item[1]?.adv_spent).toFixed(2) : 0}
                        </td>
                      )}

                    {((localStorage.getItem("role") === roles.ops) || (localStorage.getItem("role") === roles.advertiser && tablePermissions.includes('spent')) || (localStorage.getItem("role") === roles.salesperson && tablePermissions.includes('spent')) || localStorage.getItem("role") === roles.financer) ? (item ? <td>{(item[1]?.total_spent).toFixed(2)}</td> : <td>{0}</td>) : null}

                    {localStorage.getItem("role") === roles.ops && (
                      <td className="p-2">
                        {item ? parseInt(
                          item[1]?.encrypt_adv_imp > 0 ? item[1]?.encrypt_adv_imp : 0
                        ) : 0}
                      </td>
                    )}

                    {localStorage.getItem("role") === roles.ops && (
                      <td className="p-2">
                        {item ? parseInt(
                          item[1]?.encrypt_imp > 0 ? item[1]?.encrypt_imp : 0
                        ) : 0}
                      </td>
                    )}
                    
                    {localStorage.getItem("role") === roles.ops && (
                      <td className="p-2">
                        {item ? parseInt(
                          item[1]?.actual_clicks > 0 ? item[1]?.actual_clicks : 0
                        ) : 0}
                      </td>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <td className="p-2">
                        {item ? parseInt(item[1]?.shares > 0 ? item[1]?.shares : 0) : 0}
                      </td>
                    )}
                    <td>
                    <div className="d-flex gap-3" style={{ fontSize: "20px" }}>
                        <sl-tooltip content="Preview Creative">
                          <sl-icon-button
                            library="lucide"
                            name="view"
                            onClick={() => { if(citem.creative_type !== "brandAd")setCreativePreview([citem]); else getPostViews(citem.creative_id) }}></sl-icon-button>
                        </sl-tooltip>
                        </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : !data?.length && !loader ? (
            <NoDataFound colspan="15" />
          ) : (
            <TableLoader colspan="15" />
          )}
        </table>
      </div>
      <div>
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}
      </div>
      
      {Object.keys(creativePreview).length > 0 ? <SlDrawer open={creativePreview.length > 0} onSlAfterHide={() => setCreativePreview([])} style={{'--size':`${window.innerWidth <= 767 ? '100vw' : '30vw'}`}}>
    <section className="basis-5/12 rounded-2xl overflow-hidden">
        {<> {(creativePreview.length > 0 ?
            <Swiper
                spaceBetween={0}
                pagination={true}
                navigation={true}
                modules={[Navigation, Pagination]}
                className="mySwiper"
                style={{ width: "460px" }}>
                {creativePreview.map((campPreview) => <SwiperSlide><creativewiseReportsContext.Provider value={{ campPreview }}><PreviewFrameEdit showPreview={true} /></creativewiseReportsContext.Provider></SwiperSlide>)}</Swiper> : null)} </>}
    </section>
      </SlDrawer> : null}
    </>
  );
}

export default CreativeWise;
